module.exports = __webpack_public_path__ + "static/img/image1.4b99abf1.png";